/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

PrivacyToolsCtrl.$inject = [
    '$q',
    '$sce',
    '$scope',
    '$stateParams',
    '$window',
    '$httpParamSerializer',
    'iframeSrcKey',
    'AccountAuthService',
    'AnalyticsService',
    'UtilService'
];
function PrivacyToolsCtrl(
    $q,
    $sce,
    $scope,
    $stateParams,
    $window,
    $httpParamSerializer,
    iframeSrcKey,
    AccountAuthService,
    AnalyticsService,
    UtilService
) {
    const vm = this;

    updateIframeSrc();
    AccountAuthService.onEveryAuthChange('privacyToolsGetAuth', updateIframeSrc);
    angular.element($window).on('message', onWindowMessage);

    $scope.$on('$destroy', () => {
        angular.element($window).off('message', onWindowMessage);
    });

    /**
     * Updates the iframe's src path. Should get called on every auth change so that
     * the iframe's page is aware of whether or not the user is logged in and what
     * their email address is.
     * 
     * @return {Promise} resolves once the src is updated
     */
    function updateIframeSrc() {
        let privacyIframeSrc = UtilService.getSiteSetting('privacy_tools_iframe_src', {})[iframeSrcKey];
        if (!privacyIframeSrc) return;

        const tokenConfirmViews = ['verify', 'download'];
        if (tokenConfirmViews.includes(iframeSrcKey)) {
            privacyIframeSrc += `${$stateParams.referenceId}/${$stateParams.token}/`;
        }

        return getIframeQueryParams().then((iframeSrcQueryParams) => {
            privacyIframeSrc += '?' + $httpParamSerializer(iframeSrcQueryParams);
            vm.privacyIframeSrc = $sce.trustAsResourceUrl(privacyIframeSrc);
        });
    }

    /**
     * Gets the query params to pass into the iframe's src.
     * 
     * @return {Promise<Object>} resolves with an object map of query params
     */
    function getIframeQueryParams() {
        const iframeSrcQueryParams = {
            utility: UtilService.getSetting('utilitySlug'),
        };
        return getUserEmail().then((email) => {
            if (email) {
                iframeSrcQueryParams.email = email;
            }

            return iframeSrcQueryParams;
        });
    }
    
    /**
     * Gets the user's email, if the user is logged in. Otherwise, simply returns
     * a blank string.
     * 
     * @return {Promise<string>} resolves with the user's email or an empty string
     */
    function getUserEmail() {
        return AccountAuthService.checkIfUserLoggedIn().then(() => {
            if (!AccountAuthService.isAuthenticated()) return $q.resolve('');
            return AccountAuthService.fetchCurrentUserInfo().then(() => {
                const user = AccountAuthService.getCurrentUser();
                if (user && user.email) return user.email;
                return '';
            });
        });
    }

    /**
     * Callback for when the window receives a posted message from an iframe.
     * If the proper 'eventType' value is present in the data, then a Segment
     * event is fired to track the event type.
     * 
     * @param {*} e 
     */
    function onWindowMessage(e) {
        const data = e.originalEvent.data;
        if (data.eventType !== 'consumer_request_submitted') return;
        AnalyticsService.reportEvent('Consumer Request Submitted', {
            request_type: data.requestType,
        });
    }
}

module.exports = PrivacyToolsCtrl;